import React, { useCallback, useState, useEffect } from "react";
import {ButtonContainer, PageContainer} from "../survey-tools/ui-components/containers"
import {TextField, Typography, Button} from "@mui/material"
import fscreen from "fscreen"
import {nextTask} from "../study-logic/study-redux-slice"
import {connect} from "react-redux"

const makeDateString = () => {
    const d = new Date()
    const year = d.getFullYear().toString()
    const month = ('0' + (d.getMonth() + 1)).slice(-2)
    const day = ('0' + d.getDate().toString()).slice(-2)

    return year + month + day
}


const OpenScreen = ({ nextTask }) => {
    const [value, setValue] = useState('');
    const [buttonDisabled, setButtonDisabled] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        let prolificId = urlParams.get('PROLIFIC_PID') || '';

        // Regex to extract alphanumeric part
        const matches = prolificId.match(/[a-zA-Z0-9]+/);
        if (matches) {
            prolificId = matches[0];
        }

        setValue(prolificId);
        setButtonDisabled(prolificId.length !== 24);
    }, []);

    const handleNext = useCallback(() => {

        nextTask({ userVars: {
            userID: value, date: makeDateString(), startTime: Date.now()
        }});
    }, [value]);

    const updateText = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
        setButtonDisabled(newValue.length !== 24);
    };

    return (
        <PageContainer>
            <Typography>What is your Prolific ID? Please note that this response should auto-fill with the correct ID.</Typography>
            <TextField 
                autoFocus 
                value={value} 
                size={"small"}
                sx={{ margin: ".5em" }}
                onChange={updateText} 
            />
            <ButtonContainer>
                <Button 
                    variant={'contained'}
                    onClick={handleNext} 
                    disabled={buttonDisabled}
                >
                    Next
                </Button>
            </ButtonContainer>
        </PageContainer>
    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(OpenScreen);